import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogClose, MatDialogModule } from "@angular/material/dialog";
import { DatePipe } from "@angular/common";
import { ButtonComponent } from "../layout/element/button.component";
import { Review } from "../../../../globalTypes/review.types";
import { RatingComponent } from "./rating.component";
import { UploadImageComponent } from "../image/upload-image.component";
import { ImageUploadPublic } from "../../../../globalTypes/image.types";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UploadService } from "../../services/upload.service";

export interface ViewProductReviewData {
  review: Review
}

@Component({
  selector: 'msh-view-product-review-dialog',
  imports: [MatDialogModule, RatingComponent],
  template: `
<div class=" text-copy min-w-[50vw]">
  <mat-dialog-content>
    <div class="flex flex-col gap-4">
      <div class=" flex justify-between gap-2">
        <div class="text-lg font-semibold">{{review.isBuyer ? 'Buyer' : 'Seller'}} Review</div>
        <msh-rating [(rating)]="review.rating" [readonly]="true"></msh-rating>
      </div>
      {{review.title}}
      <div class="flex flex-col gap-2">
        {{review.body}}
      </div>
      <div class="flex flex-wrap gap-2">
        @for(existingImage of existingImages; track existingImage; let i = $index){
          <div class="max-w-48 h-16 bg-copy/10 flex items-center justify-center overflow-hidden rounded">
            <img
              [src]="existingImage.image.url"
              class="max-h-full max-w-full object-contain"
            />
          </div>
        }
      </div>
      <!-- add more info here if it exists -->
       @if(review.fulfillment && review.fulfillment.order && review.fulfillment.order.orderItems_on_order){
         <div class="text-sm text-copy/50">
           Listing{{review.fulfillment.order.orderItems_on_order.length === 1 ? '' : 's'}}: 
           @for(existingItem of review.fulfillment.order.orderItems_on_order; track existingItem; let i = $index){
             {{existingItem.listingVariation.listing.name}}{{i < review.fulfillment.order.orderItems_on_order.length - 1 ? ', ' : ''}}
           }
         </div>
       }
    </div>
  </mat-dialog-content>
</div>
  `,
  styles: ``
})
export class ViewProductReviewDialogComponent {

  messageToBuyer: string = '';
  newImages: {image: ImageUploadPublic; sortOrder: number}[] = [];
  isLoading = false;
  existingImages: { image: ImageUploadPublic; sortOrder: number }[] = [];
  removeImageIds: string[] = [];
  review!: Review;

  constructor(
    public dialogRef: MatDialogRef<ViewProductReviewDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ViewProductReviewData
  ){
    this.review = this.data.review;
    this.existingImages = this.review.reviewImages_on_review || [];
  }
}